import { createRouter, createWebHistory } from 'vue-router'
import store from '../store';
import layout1 from '../layouts/layout/layout1.vue'

import dashboard from '../pages/dashboard.vue'
import dashboardInit from '../pages/dashboardInit.vue'
import allUsers from '../pages/general/users/all_users.vue'
import add_new_user from '../pages/general/users/add_new_user.vue'

import orders from '../pages/application/order/orders.vue'
import edit_order from '../pages/application/order/edit_order.vue'
import order_list from '../pages/application/orders_plantilla/order_list.vue'
import order_detail from '../pages/application/orders_plantilla/order_detail.vue'
import order_tracking from '../pages/application/orders_plantilla/order_tracking.vue'
import translation from '../pages/application/localization/translation.vue'
import currency_rate from '../pages/application/localization/currency_rate.vue'
import taxes from '../pages/application/localization/taxes.vue'
import products from '../pages/application/product/products.vue'
import add_product from '../pages/application/product/add_new_product.vue'
import edit_product_comment from '../pages/application/product/edit_product_comment.vue'
import edit_product from '../pages/application/product/edit_product.vue'
import comments_products from '../pages/application/product/comments_products.vue'
import logs from '../pages/application/log/logs.vue'
import vendors from '../pages/application/vendor/vendors.vue'
import add_vendor from '../pages/application/vendor/add_new_vendor.vue' 
import edit_vendor from '../pages/application/vendor/edit_vendor.vue'
import carriers from '../pages/application/carrier/carriers.vue'
import add_carrier from '../pages/application/carrier/add_new_carrier.vue' 
import link_apis from '../pages/application/external_APIs/linkAPIs.vue' 
import cj_products_explorer from '../pages/application/external_APIs/cj_products_explorer.vue'
import edit_carrier from '../pages/application/carrier/edit_carrier.vue'
import blogs from '../pages/application/blog/blogs.vue'
import add_blog from '../pages/application/blog/add_new_blog.vue'
import edit_blog from '../pages/application/blog/edit_blog.vue'
import categorys from '../pages/application/category/categorys.vue'
import add_category from '../pages/application/category/add_new_category.vue' 
import edit_category from '../pages/application/category/edit_category.vue'
import coupon_list from '../pages/application/coupons/coupon_list.vue'
import create_coupon from '../pages/application/coupons/create_coupon.vue'
import product_review from '../pages/application/product_review.vue'
import invoice from '../pages/application/invoice.vue'
import support_ticket from '../pages/application/support_ticket.vue'
import profile_setting from '../pages/application/settings/profile_setting.vue' 
import reports from '../pages/application/reports.vue'
import list_page from '../pages/application/list_page.vue'
import log_in from '../pages/application/log_in.vue'
import forgot_password from '../pages/application/forgot_password.vue'
import register from '../pages/application/register.vue'

const routes = [
    {
        path: '/',
        name: 'dashboardInit',
        component: dashboardInit,
        beforeEnter: (to, from, next) => {
            if(!store.getters['isAuthenticated']) {
                return next({
                    name: 'log_in'
                })
            } else {
                next()
            }
        },
        meta: {
            layout: layout1,
            authorize: [ 
              "ROLE_ADMIN"
            ],
            breadcrumb: {
                type: 0
            }
        },
        children: [
            {
                path: '',
                components: {
                    routerviewadmin: dashboard
                },
                name: 'dashboard',
                meta: {
                    breadcrumbs: [
                        {
                            name: 'Inicio/'
                        }
                    ]
                }
            },
            {
                path: 'all_users',
                name: 'allUsers',
                components: {
                    routerviewadmin: allUsers
                },
                meta: {
                    layout: layout1,
                    breadcrumb: { type: 1, title: 'All Users', buttonPath: '/add_new_user' }
                }
            },
            {
                path: 'add_new_user',
                name: 'add_new_user',
                components: {
                    routerviewadmin: add_new_user
                },
                meta: {
                    layout: layout1,
                    breadcrumb: { type: 2, title: 'Add New User' }
                }
            },
            {
                path: 'orders',
                name: 'orders',
                components: {
                    routerviewadmin: orders
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Orders List' } }
            },
            {
                path: 'edit_order/:id',
                name: 'edit_order',
                
                components: {
                    routerviewadmin: edit_order
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Order' } }
            },
            {
                path: 'order_list',
                name: 'order_list',
                components: {
                    routerviewadmin: order_list
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Order List' } }
            },
            {
                path: 'order_detail',
                name: 'order_detail',
                components: {
                    routerviewadmin: order_detail
                },
                meta: {
                    layout: layout1,
                    breadcrumb: {
                        type: 3,
                        title: 'Order #36648',
                        lis: ['October 21, 2021 at 9:08 pm', '6 items', 'Total $5,882.00']
                    }
                }
            },
            {
                path: 'order_tracking',
                name: 'order_tracking',
                components: {
                    routerviewadmin: order_tracking
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Order Tracking' } }
            },
            {
                path: 'vendors',
                name: 'vendors',
                components: {
                    routerviewadmin: vendors
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Vendor List' } }
            },
            { 
                path: 'add_vendor',
                name: 'add_vendor',
                components: {
                    routerviewadmin: add_vendor
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Create Vendor' } }
            },
            {
                path: 'edit_vendor/:id',
                name: 'edit_vendor',
                
                components: {
                    routerviewadmin: edit_vendor
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Vendor' } }
            },
            {
                path: 'carriers',
                name: 'carriers',
                components: {
                    routerviewadmin: carriers
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Carrier List' } }
            },
            { 
                path: 'add_carrier',
                name: 'add_carrier',
                components: {
                    routerviewadmin: add_carrier
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Create carrier' } }
            },
            {
                path: 'edit_carrier/:id',
                name: 'edit_carrier',
                
                components: {
                    routerviewadmin: edit_carrier
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Carrier' } }
            },
            { 
                path: 'link_apis',
                name: 'link_apis',
                components: {
                    routerviewadmin: link_apis
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Link APIs' } }
            },
            {
                path: 'cj_products_explorer',
                name: 'cj_products_explorer',
                components: {
                    routerviewadmin: cj_products_explorer
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'CJ Products Explorer' } }
            },
            {
                path: 'translation',
                name: 'translation',
                components: {
                    routerviewadmin: translation
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Translation' } }
            },
            {
                path: 'currency_rate',
                name: 'currency_rate',
                components: {
                    routerviewadmin: currency_rate
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Currency Rates' } }
            },
            {
                path: 'taxes',
                name: 'taxes',
                components: {
                    routerviewadmin: taxes
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Taxes' } }
            },
            {
                path: 'products',
                name: 'products',
                components: {
                    routerviewadmin: products
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Products' } }
            },
            {
                path: 'add_product',
                name: 'add_product',
                components: {
                    routerviewadmin: add_product
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Add Product' } }
            },
            {
                path: 'comments_products',
                name: 'comments_products',
                components: {
                    routerviewadmin: comments_products
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Comments Products' } }
            },
            {
                path: 'logs',
                name: 'logs',
                components: {
                    routerviewadmin: logs
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Logs' } }
            },
            {
                path: 'edit_product_comment/:id',
                name: 'edit_product_comment',
                components: {
                    routerviewadmin: edit_product_comment
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Product Comment' } },
                props: true
            },
            {
                path: 'blogs',
                name: 'blogs',
                components: {
                    routerviewadmin: blogs
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Blogs' } }
            },
            {
                path: 'add_blog',
                name: 'add_blog',
                components: {
                    routerviewadmin: add_blog
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Add Blog' } }
            },
            {
                path: 'edit_product/:id',
                name: 'edit_product',
                
                components: {
                    routerviewadmin: edit_product
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Product' } }
            },
            {
                path: 'edit_blog/:id',
                name: 'edit_blog',
                
                components: {
                    routerviewadmin: edit_blog
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Blog' } }
            },
            
            {
                path: 'categorys',
                name: 'categorys',
                components: {
                    routerviewadmin: categorys
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Category List' } }
            },
            { 
                path: 'add_category',
                name: 'add_category',
                components: {
                    routerviewadmin: add_category
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Category Vendor' } }
            },
            {
                path: 'edit_category/:id',
                name: 'edit_category',
                
                components: {
                    routerviewadmin: edit_category
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Edit Category' } }
            },
            {
                path: 'coupon_list',
                name: 'coupon_list',
                components: {
                    routerviewadmin: coupon_list
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Coupon List' } }
            },
            {
                path: 'create_coupon',
                name: 'create_coupon',
                components: {
                    routerviewadmin: create_coupon
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Create Coupon' } }
            },
            {
                path: 'product_review',
                name: 'product_review',
                components: {
                    routerviewadmin: product_review
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Product Review' } }
            },
            {
                path: 'invoice',
                name: 'invoice',
                components: {
                    routerviewadmin: invoice
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Invoice' } }
            },
            {
                path: 'support_ticket',
                name: 'support_ticket',
                components: {
                    routerviewadmin: support_ticket
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'Support Ticket' } }
            },
            {
                path: 'profile_setting',
                name: 'profile_setting',
                components: {
                    routerviewadmin: profile_setting
                },
                meta: {
                    layout: layout1,
                    breadcrumb: { type: 2, title: 'Profile Setting' }
                }
            },
            {
                path: 'reports',
                name: 'reports',
                components: {
                    routerviewadmin: reports
                },
                meta: {
                    layout: layout1,
                    breadcrumb: { type: 2, title: 'Report' }
                }
            },
            {
                path: 'list_page',
                name: 'list_page',
                components: {
                    routerviewadmin: list_page
                },
                meta: { layout: layout1, breadcrumb: { type: 2, title: 'List Page' } }
            },
            {
                path: 'forgot_password',
                name: 'forgot_password',
                components: {
                    routerviewadmin: forgot_password
                },
            },
            {
                path: 'register',
                name: 'register',
                components: {
                    routerviewadmin: register
                }
            }
        ]
    },
    {
        path: '/log_in',
        name: 'log_in',
        component: log_in
    },
    
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach( (to, from, next) => {
  let permissionsUser = store.getters['getRolesUser'];
  let permissionsRoute = to.meta.authorize;

  // Si el usuario está autenticado
  if(store.getters['isAuthenticated']) {
      // Si la ruta no tiene permisos entonces es pública
      if(permissionsRoute === undefined || permissionsRoute === null) {
          return next();
      }

      // Si la ruta tiene permisos verificamos que el usuario tenga algun permiso que conincida
      // y si no coincide le redirigimos a "dashboardinitpage"
      if(permissionsRoute.some(pr => permissionsUser.includes(pr)) === false) {
          return next({
              name: 'log_in'
          });
      }

      if(permissionsUser.includes('ROLE_ADMIN')) {
          next();
      }

      
      
      
  } else {
      return next();
  }
})



export default router
